import { IBaseCellsProps } from '../cells.interfaces';
import {
    CellWrapper,
    LoadingWrapper,
    RangeBlockWrapper,
    StyledTableCell,
} from './CellRangeBlocks.styles';
import { RangeBlocks, Typography, useTheme } from '../../../base-components';
import { createScoreRangeConfig, overallScoreLabels } from '../../../../common';
import { useTranslation } from 'react-i18next';
import PargodaLoading from '../../../../components/PargodaLoading';

interface Props extends IBaseCellsProps {
    data: {
        rangeBlockFrom: number;
        rangeBlockTo: number;
        rangeBlockColor: string;
        notApplicable?: boolean;
    };
}
const CellRangeBlocks = (props: Props) => {
    const {
        alignment,
        columnIndex,
        isRowSelected,
        stickyColumn,
        rowStickyWidths,
        data,
    } = props;
    const { t } = useTranslation();
    const theme = useTheme();
    const scoreRangeConfig = createScoreRangeConfig();
    const { rangeBlockFrom, rangeBlockTo, rangeBlockColor, notApplicable } = data;
    const rangeBlockText = overallScoreLabels.find(
        (label) => label.value === rangeBlockTo
    )?.label;

    const renderScoreContent = () => {
        if (rangeBlockTo >= 0 && rangeBlockTo !== null) {
            return (
                <>
                    <RangeBlockWrapper>
                        <RangeBlocks
                            externalValue={{
                                from: rangeBlockFrom,
                                to: rangeBlockTo,
                            }}
                            disabled
                            showSelectionText={false}
                            scoreRangeConfig={scoreRangeConfig}
                            fillColor={rangeBlockColor}
                        />
                    </RangeBlockWrapper>
                    <Typography variant="body2" color={rangeBlockColor}>
                        {t(`applicationsPage.${rangeBlockText}`)}
                    </Typography>
                </>
            );
        }
        if (notApplicable) {
            return (
                <Typography
                    variant="body2"
                    color={theme.palette.text.secondary}
                >
                    {t('applicationsPage.notApplicable')}
                </Typography>
            );
        }
        return (
            <>
                <LoadingWrapper>
                    <PargodaLoading height={30} width={30} />
                </LoadingWrapper>
                <Typography
                    variant="body2"
                    color={theme.palette.text.secondary}
                >
                    {t('applicationsPage.processingResume')}
                </Typography>
            </>
        );
    };

    return (
        <StyledTableCell
            alignment={alignment}
            columnIndex={columnIndex}
            isSelected={isRowSelected}
            rowStickyWidths={rowStickyWidths}
            stickyColumn={stickyColumn}
        >
            <CellWrapper>
                {renderScoreContent()}
            </CellWrapper>
        </StyledTableCell>
    );
};

export default CellRangeBlocks;
